var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportBox',{staticClass:"views-report",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h5',[_vm._v("Views")])]},proxy:true}])},[_c('LineChart',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }